/**
 * Blueprint for the sidebar options entity.
 */
export class SidebarOptions {
  public isOpened: boolean;
  public hasSidebar: boolean;

  constructor(isOpened: boolean, hasSidebar: boolean) {
    this.isOpened = isOpened;
    this.hasSidebar = hasSidebar;
  }
}
